import { useQuery } from "react-query";
import { wt_rekruttering, wt_tilbud } from "../../constants/WebtempTyper";
import { jobsAPI } from "../../api/jobs";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../url/wsQueryStringStore";

export interface IUseAdIrelTrelParams {
  typeRelated: number;
  idRelated: number;
}

export const useAdIrelTrel = ({
  typeRelated,
  idRelated,
}: IUseAdIrelTrelParams) => {
  if (!typeRelated && !idRelated && queryStringStore.qs[CVPSearchParams.cvpr]) {
    idRelated = Number(queryStringStore.qs[CVPSearchParams.cvpr]);
    typeRelated = wt_rekruttering;
  }

  if (!typeRelated && !idRelated && queryStringStore.qs[CVPSearchParams.cvpt]) {
    idRelated = Number(queryStringStore.qs[CVPSearchParams.cvpt]);
    typeRelated = wt_tilbud;
  }

  const { data } = useQuery(
    "getCurrentApplicationItem",
    () =>
      jobsAPI.getCurrentApplicationItem({
        idConcern: window.cvpIdConcern,
      }),
    {
      enabled:
        !!jobsAPI.getCurrentApplicationItem && (!typeRelated || !idRelated),
    }
  );

  const idRelatedResolved = data?.idRelated || idRelated;
  const typeRelatedResolved = data?.typeRelated || typeRelated;

  return { idRelatedResolved, typeRelatedResolved };
};
